<template>
<div class="p-0">
   <!--
        <div v-if="message" class="alert" :class="successful ? 'alert-success' : 'alert-danger'">
   <div  class="fp-onOff btn-info rounded"
   <div v-if="bdResume"
         class="bd-resume px-1 position-relative" 
   -->
   <div
      class="position-relative" 
      :class="bdClass"
      :style="{'background-color': board.bg_color, 'color': board.text_color}"
      :title='titleToShow'
      >
         <b>{{board.shortName}}</b>
         <span v-if="board.startTheCard"
               class="position-absolute 
                  top-0 start-90 
                  translate-middle 
                  p-1 bg-danger 
                  border border-light 
                  rounded-circle">
         </span>
   </div>
   <!--
   <div v-else
         class="bd-normal px-2 position-relative" 
         :style="{'background-color': board.bg_color, 'color': board.text_color}"
         :title='board.name'
         >
            <b>{{board.shortName}}</b>
            <span v-if="board.startTheCard"
                  class="position-absolute 
                     top-0 start-90 
                     translate-middle 
                     p-1 bg-danger 
                     border border-light 
                     rounded-circle">
            </span>
   </div>
   -->
</div>
</template>

<script>
import { computed } from '@vue/reactivity'

export default {

   props: {
      board: {
         type: Object,
         required: true
      },
      small: Boolean,
      selected: {
         type: Boolean,
         default: true
      },
      cellName: {
         type: Boolean,
         default: true
      },
   },

   setup(props) {
      const bdClass = computed(() => {
         let retClass = ""
         let crsClass = " crs-text"
         if (props.small) {
            retClass = "bd-resume px-1"
         } else {
            retClass = "bd-normal px-2"
            if (!props.board.canShow || !props.selected) {
               retClass = retClass + " bd-opacity"
            }
            if (!props.board.canShow) {
               crsClass = " crs-not"
            } else if (!props.selected) {
               crsClass = " crs-pointer"
            }
            retClass = retClass + crsClass
         }
         return retClass
      })
      const titleToShow = computed(() => {
         if ( props.small || !props.cellName ) {
            return props.board.name
         } else {
            return '"' + props.board.name + '" en la lista "' + props.board.cellName + '"'
         }
      })
      /*
      const bdClass = computed(() => {
         if (props.format == "filter")
            return "bd-filter btn-board rounded"
         if (props.format == "onOff")
            return "bd-onOff btn-board rounded"
      })
      const bdResume = computed(() => {
         if (props.format == "resume") {
            return true
         } else {
            return false
         }
      })
      */
      return {
         bdClass, titleToShow
      }
   }
}
</script>

<style scoped>
.bd-onOff {
  width: 333px;
  height: 26px;
}
.bd-filter {
  height: 26px;
}
.btn-board {
   opacity: .8;
}
.btn-board:hover {
   opacity: 1;
}
.bd-resume {
   width: auto;
   height: 19px;
   font-size: 12px;
}
.bd-resume-into {
   width: 14px;
   height: 7px;
   position: relative;
   top: 1px;
   left: 16px;
   /*clip-path: polygon();*/
}
.bd-normal {
   width: auto;
   height: 24px;
   font-size: 14px;
}
.bd-opacity {
   opacity: .3;
}
.crs-pointer {
   cursor: pointer;
}
.crs-pointer:hover {
   opacity: 1;
}
.crs-not {
   cursor: not-allowed;
}
.crs-text {
   cursor: text;
}
</style>